
const BUILD_ENV = process.env.REACT_APP_BUILD_ENV || "local";

export const baseUrl = BUILD_ENV === 'prod' ?
  "https://api.projectcity.tv/" :
  "http://localhost:8000/";
